<div style="width: 82%; margin-bottom: 20px; margin-left: 22px; margin-top: 10px;" >
    <owl-carousel-o [options]="customOptions" >
  
       <ng-template carouselSlide *ngFor="let item of items" style="width: 130px; padding-bottom: 10px;"
      
       >
        <div class="picsum-img-wrapper" style="width: 120px;">
          <div class="chat-our-team-box"
          (click)="redirectTOProduct(item.link_url)"
          >
            <div class="team-boxes"
            [class.active-box]="selectedDoctor == item.text"
            
            >
  
           
            
              <div class="nopersonimagecontianer">
              <!-- <i class="fa fa-user"></i> -->
               <img [src]="item.img_url" alt=""
               (error)="onImgError($event)"
               class="product_image" />
            </div>
            
             <!-- <p class="profession">
              {{item.company}}
             </p> -->
             <div class="buy_now_Btn"
             (click)="redirectTOProduct(item.link_url)"
             >
                {{item.button_text}}
             </div>
            </div>
  
          
          </div>
        </div>
      </ng-template>  
  
    </owl-carousel-o>
  </div>
  
  